(function(){
var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function ready(fn){if(document.readyState!='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
ready(function(){
try{
var b=document.createElement('button');b.className='np-top';b.setAttribute('aria-label','Back to top');
b.innerHTML='<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18 15l-6-6-6 6\"/></svg>';
document.body.appendChild(b);
b.addEventListener('click',function(){window.scrollTo({top:0,behavior:rm?'auto':'smooth'});});
window.addEventListener('scroll',function(){if(window.pageYOffset>500){b.classList.add('np-show');}else{b.classList.remove('np-show');}},{passive:true});
if(rm)return;
var nodes=document.querySelectorAll('.index-section,.grid__item,.grid-product,.section-header');
if('IntersectionObserver' in window){
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('np-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
nodes.forEach(function(n,i){n.classList.add('np-reveal');if(i%3===1)n.classList.add('np-d1');if(i%3===2)n.classList.add('np-d2');io.observe(n);});
}
}catch(e){}
});
})();